const common = {
  'en': 'English',
  'vi': 'Tiếng Việt',
};

export default common;
